<template lang="pug">
    .section-big-illust(
        v-observe-visibility="(isVisible, entry)=>{visibilityChanged(isVisible, entry, content.animated)}"
    )

        .plotkin-big-illustration-1(v-if="content.id === 'plotkin-big-illustration-1'")
            .plotkin-big-illustration-1__trajectory
                img(src='@/assets/img/articles/plotkin/big-illustrations/plotkin-big-ill-1-trajectory.png' alt="")
                .plotkin-big-illustration-1__plane
                    img(src='@/assets/img/articles/plotkin/big-illustrations/plotkin-big-ill-1-plane.png' alt="Бомбардировщик")
                .plotkin-big-illustration-1__medal
                    img(src='@/assets/img/articles/plotkin/big-illustrations/plotkin-big-ill-1-medal.png' alt="Орден Ленина")
                .plotkin-big-illustration-1__text 50

        .plotkin-big-illustration-2(v-else-if="content.id === 'plotkin-big-illustration-2'")
            .plotkin-big-illustration-2__plane
                img(src='@/assets/img/articles/plotkin/big-illustrations/plotkin-big-ill-2-plane.png' alt="")

        .sultan-big-illustration-1(v-else-if="content.id === 'sultan-big-illustration-1'")
            .sultan-big-illustration-1__clouds
            .sultan-big-illustration-1__img-wrp
                picture
                    source(srcset="@/assets/img/articles/sultan/big-illustrations/sultan-big-ill-1-mobile.png" media="(max-width: 768px)" alt="")
                    img.sultan-big-illustration-1__img(src='@/assets/img/articles/sultan/big-illustrations/sultan-big-ill-1.png' alt="")

        .sultan-big-illustration-2(v-else-if="content.id === 'sultan-big-illustration-2'")
            .sultan-big-illustration-2__wrp
                .sultan-big-illustration-2__wrp-img
                    picture
                        source(srcset="@/assets/img/articles/sultan/big-illustrations/sultan-big-ill-2-plane-mobile.png" media="(max-width: 768px)" alt="")
                        img(src='@/assets/img/articles/sultan/big-illustrations/sultan-big-ill-2-plane.png' alt="")
                .sultan-big-illustration-2__stars
                .sultan-big-illustration-2__text 150

        .sultan-big-illustration-3(v-else-if="content.id === 'sultan-big-illustration-3'")
            Strap.strap_dark.sultan-big-illustration-3__strap(text="Чистое <span class='strap__red'>небо</span>")
            .sultan-big-illustration-3__plane

        .sultan-big-illustration-4(v-else-if="content.id === 'sultan-big-illustration-4'")
            .sultan-big-illustration-4__plane
                img(src='@/assets/img/articles/sultan/big-illustrations/sultan-big-ill-4-plane.png' alt="")

        .german-big-illustration-1(v-else-if="content.id === 'german-big-illustration-1'")

            .german-big-illustration-1__lines
            .german-big-illustration-1__img-wrp
                img(src='@/assets/img/articles/german/big-illustrations/german-big-ill-1-people.png' alt="")

        .german-big-illustration-2(v-else-if="content.id === 'german-big-illustration-2'")
            Strap.strap_dark.german-big-illustration-2__strap(text="Парень <br class='hide-br-laptop'><span class='strap__red'>с лиговки</span>")
            .german-big-illustration-2__tank

        .german-big-illustration-3(v-else-if="content.id === 'german-big-illustration-3'")
            .german-big-illustration-3__map
            .german-big-illustration-3__binoculars-wrp
                .german-big-illustration-3__binoculars
                    img(src="@/assets/img/articles/german/big-illustrations/german-big-ill-3-binoculars.png" alt="")
                .german-big-illustration-3__cross-angle
                .german-big-illustration-3__scale

        .german-big-illustration-4(v-else-if="content.id === 'german-big-illustration-4'")
            .german-big-illustration-4__map
            .german-big-illustration-4__arrows

        .german-big-illustration-5(v-else-if="content.id === 'german-big-illustration-5'")
            .german-big-illustration-5__binoculars
                img.german-big-illustration-5__binoculars-img(src='@/assets/img/articles/german/big-illustrations/german-big-ill-5.png' alt="")

        .dachiev-big-illustration-1(v-else-if="content.id === 'dachiev-big-illustration-1'")
            img(src="@/assets/img/articles/dachiev/big-illustrations/dachiev-big-illustration-1.png" alt="")
        .dachiev-big-illustration-2(v-else-if="content.id === 'dachiev-big-illustration-2'")
            img(src="@/assets/img/articles/dachiev/big-illustrations/dachiev-big-illustration-2.png" alt="")

        .dachiev-big-illustration-3(v-else-if="content.id === 'dachiev-big-illustration-3'")
            .dachiev-big-illustration-3__image-wrp
                img.dachiev-big-illustration-3__image(src="@/assets/img/articles/dachiev/big-illustrations/dachiev-big-illustration-3.png" alt="")

        .basanov-big-illustration-1(v-else-if="content.id === 'basanov-big-illustration-1'")
            picture
                source(srcset="@/assets/img/articles/basanov/big-illustrations/basanov-big-illustration-1-mobile.png" media="(max-width: 425px)" alt="Карта Режицко-Двинской операции")
                img.basanov-big-illustration-1__image(src="@/assets/img/articles/basanov/big-illustrations/basanov-big-illustration-1.png" alt="Карта Режицко-Двинской операции")

        .basanov-big-illustration-2(v-else-if="content.id === 'basanov-big-illustration-2'")
            .basanov-big-illustration-2__image-wrp
                img.basanov-big-illustration-2__image(src="@/assets/img/articles/basanov/big-illustrations/basanov-big-illustration-2.png" alt="")
        .ohlopkov-big-illustration-1(v-else-if="content.id === 'ohlopkov-big-illustration-1'")
            img.ohlopkov-big-illustration-1__image(src="@/assets/img/articles/ohlopkov/big-illustrations/ohlopkov-big-illustration-1.png" alt="Карта Ржевской битвы")
            .ohlopkov-big-illustration-1__division

        .ohlopkov-big-illustration-2(v-else-if="content.id === 'ohlopkov-big-illustration-2'")
            .ohlopkov-big-illustration-2__image-wrp
                img.ohlopkov-big-illustration-2__image(src="@/assets/img/articles/ohlopkov/big-illustrations/ohlopkov-big-illustration-2.png" alt="")

        .domogakov-big-illustration-1(v-else-if="content.id === 'domogakov-big-illustration-1'")
            img.domogakov-big-illustration-1__image(src="@/assets/img/articles/domogakov/big-illustrations/domogakov-big-illustration-1.png" alt="Карта битвы за Днепр")
            .domogakov-big-illustration-1__tank
        .domogakov-big-illustration-2(v-else-if="content.id === 'domogakov-big-illustration-2'")
            img.domogakov-big-illustration-2__image(src="@/assets/img/articles/domogakov/big-illustrations/domogakov-big-illustration-2.png" alt="")
            .domogakov-big-illustration-2__man
            .domogakov-big-illustration-2__train
        .domogakov-big-illustration-3(v-else-if="content.id === 'domogakov-big-illustration-3'")
            .domogakov-big-illustration-3__binoculars
                img.domogakov-big-illustration-3__binoculars-img(src='@/assets/img/articles/domogakov/big-illustrations/domogakov-big-illustration-3.png' alt="")

</template>

<script>
import Strap from '../Strap';
import * as basicScroll from 'basicscroll';
export default {
    name: 'BigIllustration',
    props: {
        content: Object
    },
    components: {
        Strap
    },
    methods: {
        visibilityChanged(isVisible, {target}, isAnimated) {
            if (!isAnimated) return;
            if (isVisible) {
                this.initbasicScroll = basicScroll.create({
                    elem: target,
                    from: 'top-bottom',
                    to: 'bottom-top',
                    direct: true,
                    props: {
                        '--transform': {
                            from: 0,
                            to: 1
                        }
                    }
                });
                this.initbasicScroll.start();
            } else {
                if (this.initbasicScroll) this.initbasicScroll.destroy();
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/assets/css/vars.scss';
.section-big-illust {
    width: 100%;
    max-width: var(--max-width);
    margin: 0 auto;
    @media (--viewport-laptop) {
        padding: calc(var(--padding-mobile) * 2) 0;
    }
}
.plotkin-big-illustration-1 {
    position: relative;

    @media (--viewport-tablet) {
        margin-bottom: 90vw;
    }

    &__plane,
    &__medal {
        position: absolute;
        top: 0;
        left: 16%;
        width: 55%;
    }

    &__plane {
        @media (--viewport-tablet) {
            width: 90%;
            left: 10%;
        }
    }

    &__medal {
        @media (--viewport-tablet) {
            width: 100%;
            left: -41%;
            top: 112%;
        }
    }

    &__text {
        position: absolute;
        top: 20%;
        left: 53%;
        font-size: 20vw;
        color: rgba(0, 0, 0, 0.3);
        font-weight: bold;

        @media (--viewport-tablet) {
            top: 146%;
            // left: 17%;
            width: 100%;
            left: 0;
            text-align: center;
            font-size: 72vw;
        }
    }

    &__trajectory {
        & > img {
            @media (--viewport-tablet) {
                opacity: 0;
            }
        }
    }
}

.plotkin-big-illustration-2 {
    position: relative;
    display: flex;
    justify-content: center;

    @media (--viewport-laptop) {
        margin-top: 0%;
    }

    &__clouds {
        width: 100%;
    }
    &__plane {
        width: 50vw;
        min-width: 370px;

        @media (--viewport-tablet) {
            margin-bottom: calc(var(--padding-mobile) * -1);
        }
    }
}

.sultan-big-illustration-1 {
    position: relative;

    &__clouds {
        position: absolute;
        background: url('../../assets/img/articles/sultan/big-illustrations/sultan-big-ill-1-clouds.png') center / auto 100% repeat-y;
        height: 200%;
        width: 100%;
        top: -50%;
    }
    &__img-wrp {
        margin: 0 auto;
        width: 67%;
        position: relative;
        z-index: 2;
        @media (--viewport-tablet) {
            width: 100%;
            padding: 0 0 calc(var(--padding-mobile) * 1);
            margin: 0;
            // transform: scale(1.1);
            // transform-origin: 0% 50%;
        }
    }
    &__img {
        display: block;
        width: 100%;
    }
}

.sultan-big-illustration-2 {
    position: relative;
    padding-right: calc(var(--padding) * 2.5);
    padding-left: calc(var(--padding) * 0.5);
    padding-bottom: calc(var(--padding) * 1);
    @media (--viewport-tablet) {
        padding: 0;
        padding-bottom: calc(var(--padding-mobile) * 2);
    }
    &__wrp {
        position: relative;
        z-index: 2;
        padding-right: 25%;
        @media (--viewport-tablet) {
            padding-right: 0;
        }
    }

    &__stars {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        width: 12%;
        background: url('../../assets/img/articles/sultan/big-illustrations/sultan-big-ill-2-stars.png') 100% 10% / contain no-repeat;
        @media (--viewport-tablet) {
            position: relative;
            width: 30%;
            padding-bottom: 27%;
            margin-left: auto;
            margin-right: var(--padding-mobile);
            background-position-y: bottom;
        }
    }
    &__text {
        font-size: 17vw;
        color: rgba(0, 0, 0, 0.3);
        font-weight: bold;
        position: absolute;
        bottom: 0;
        right: 0;
        line-height: 0.62;
        @media (--viewport-tablet) {
            position: relative;
            padding: 0 var(--padding-mobile);
            font-size: 55vw;
            line-height: 1;
            margin-bottom: -10%;
        }
    }
}

.sultan-big-illustration-3 {
    font-size: 5vw;
    padding: 2em 0 1em var(--padding);
    position: relative;
    @media (--viewport-laptop) {
        padding: 0;
        font-size: 9vw;
        line-height: 1.3;
    }
    &__strap {
        width: fit-content;
        font-size: 1em;

        @media (--viewport-laptop) {
            padding: 5vw 23vw 4vw 5vw !important;
            line-height: 1.3;
        }
    }
    &__plane {
        background: url('../../assets/img/articles/sultan/big-illustrations/sultan-big-ill-3-plane.png') center / contain no-repeat;
        width: 1.3em;
        height: 1.3em;
        position: absolute;
        top: 2em;
        right: calc(var(--padding) * 3);
        @media (--viewport-laptop) {
            display: none;
        }
    }
}

.sultan-big-illustration-4 {
    position: relative;
    display: flex;
    justify-content: center;
    @media (--viewport-laptop) {
        margin-top: 0%;
    }

    &__plane {
        width: 44vw;
        min-width: 350px;

        @media (--viewport-tablet) {
            margin-bottom: calc(var(--padding-mobile) * -1);
        }
    }
}

.german-big-illustration-1 {
    padding-left: var(--padding);
    padding-right: 26%;
    margin-bottom: -6%;
    position: relative;
    @media (--viewport-tablet) {
        padding: 0 15% 0 0;
        margin-top: calc(var(--padding-mobile) * 2);
    }
    &__lines {
        background: url('../../assets/img/articles/german/big-illustrations/german-big-ill-1-lines.png') 81% 0% / 92% auto no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        @media (--viewport-tablet) {
            transform: rotate(10deg);
            background-position: left top;
            background-size: 92% auto;
        }
    }

    @media (--viewport-laptop-l) {
        padding-left: var(--padding-mobile);
    }
    &__img-wrp {
        @media (--viewport-laptop) {
            margin-left: -25%;
        }
    }
}

.german-big-illustration-2 {
    width: fit-content;
    font-size: calc((100vw - 320px) / (1925 - 320) * (94 - 30) + 30px);
    padding-left: var(--padding);
    padding-top: 1.5em;
    padding-bottom: 2.5em;
    margin-bottom: -1.5em;
    margin-top: -0.5em;

    @media (--viewport-laptop-l) {
        padding-left: var(--padding-mobile);
    }
    @media (--viewport-tablet) {
        padding: 1em 0 1em 0;
        margin: 0;
    }

    &__strap {
        @media (--viewport-laptop) {
            margin-left: 0;
            padding: 5vw 23vw 4vw 5vw !important;
            line-height: 1.3;
            width: 100%;
        }
    }
    &__tank {
        background: url('../../assets/img/articles/german/big-illustrations/german-big-ill-2-tank.png') left top / 100% auto no-repeat;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        top: -40%;
        height: 140%;
        @media (--viewport-laptop) {
            display: none;
        }
    }
}

.german-big-illustration-3 {
    position: relative;
    margin-bottom: -6%;
    @media (--viewport-tablet) {
        padding: 10% 0;
    }
    &__map {
        position: absolute;
        top: 0;
        left: 0;
        height: 150%;
        top: -55%;
        width: 80%;
        background: url('../../assets/img/articles/german/big-illustrations/german-big-ill-3-map.png') left center / contain no-repeat;
        @media (--viewport-tablet) {
            height: 100%;
            top: -20%;
            width: 100%;
            background-size: auto 100%;
            background-position: center;
        }
    }
    &__binoculars-wrp {
        position: relative;
        padding: 10% 0;
        margin: 0 auto;
        width: 67%;
        @media (--viewport-tablet) {
            width: 100%;
            padding: 15% 0 20%;
        }
    }
    &__binoculars {
        width: 70%;
        margin: 0 auto;
        @media (--viewport-tablet) {
            width: 92%;
        }
    }
    &__cross-angle {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url('../../assets/img/articles/german/big-illustrations/german-big-ill-3-cross.png') center 8% / 5% auto no-repeat,
            url('../../assets/img/articles/german/big-illustrations/german-big-ill-3-angle.png') center 85% / 15% auto no-repeat;

        @media (--viewport-tablet) {
            background-size: 10% auto, 38% auto;
            background-position: top center, bottom center;
        }
    }

    &__scale {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url('../../assets/img/articles/german/big-illustrations/german-big-ill-3-scale.png') 0% 20% / auto 70% no-repeat;
        @media (--viewport-laptop) {
            display: none;
        }
    }
}

.german-big-illustration-4 {
    margin: -8% auto -18%;
    width: calc(100% - var(--padding) * 2);
    position: relative;
    @media (--viewport-laptop-l) {
        width: calc(100% - var(--padding-mobile) * 2);
    }
    @media (--viewport-tablet) {
        margin: 0 auto;
        width: 100%;
        margin: var(--padding-mobile) 0;
    }
    &__map {
        padding-bottom: 80%;
        background: url('../../assets/img/articles/german/big-illustrations/german-big-ill-4-men.png') 50% 23% / 70% auto no-repeat,
            url('../../assets/img/articles/german/big-illustrations/german-big-ill-4-map.png') center / contain no-repeat;
        @media (--viewport-tablet) {
            margin: 0 -15%;
            width: 130%;
            padding-bottom: 135%;
            background-size: 85%, contain;
        }
    }

    &__arrows {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url('../../assets/img/articles/german/big-illustrations/german-big-ill-4-arrows-grey.png') 5% 10% / 20% auto no-repeat,
            url('../../assets/img/articles/german/big-illustrations/german-big-ill-4-arrows-red.png') 80% 90% / 30% auto no-repeat,
            url('../../assets/img/articles/german/big-illustrations/german-big-ill-4-let.png') 90% 10% / 14% auto no-repeat;
        @media (--viewport-tablet) {
            background-size: 30%, 60%, 21%;
            background-position: 10% 0, 90% 100%, 90% 0;
        }
    }
}

.german-big-illustration-5 {
    position: relative;
    display: flex;
    justify-content: center;
    @media (--viewport-laptop) {
        margin-top: 0%;
    }

    &__binoculars {
        width: 44vw;
        min-width: 350px;
        max-width: 450px;

        @media (--viewport-tablet) {
            margin-bottom: -12%;
        }
    }
    &__binoculars-img {
        display: block;
        width: 100%;
    }
}

.dachiev-big-illustration-1 {
    margin-top: -2%;
    @media (--viewport-tablet) {
        margin-top: -20%;
        margin-left: -25%;
        margin-right: -35%;
        margin-bottom: calc(var(--padding-mobile) * -2);
    }
}

.dachiev-big-illustration-2 {
    margin-top: -20%;
    margin-left: auto;
    width: 80%;
    padding-right: calc(var(--padding) * 3);
    @media (--viewport-laptop-l) {
        padding-right: calc(var(--padding-mobile) * 3);
    }
    @media (--viewport-laptop) {
        width: 100%;
    }
    @media (--viewport-tablet) {
        padding-right: 0;
        margin-bottom: calc(var(--padding-mobile) * -4);
    }

    @media (--viewport-mobile-l) {
        width: auto;
        margin-top: -7%;
        margin-right: -13%;
        margin-left: -32%;
        padding-right: 0;
    }
}

.dachiev-big-illustration-3 {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 0;

    &__image-wrp {
        width: 70%;
        @media (--viewport-tablet) {
            width: 100%;
        }
    }
    &__image {
        display: block;
        width: 100%;
    }
}

.basanov-big-illustration-1 {
    margin-top: calc(var(--padding) * -2 - 3%);
    @media (--viewport-laptop-l) {
        margin-top: calc(var(--padding-mobile) * -2 - 3%);
    }
    @media (--viewport-tablet) {
        margin: 0 -10%;
    }
    @media (--viewport-mobile-l) {
        margin: 0;
        margin-top: calc(var(--padding-mobile) * -2 - 25%);
        margin-bottom: calc(var(--padding-mobile) * -1);
    }
    &__image {
        display: block;
        width: 100%;
    }
}

.basanov-big-illustration-2 {
    display: flex;
    justify-content: center;
    @media (--viewport-laptop) {
        margin-bottom: calc(var(--padding-mobile) * -1);
    }
    @media (--viewport-tablet) {
        margin-bottom: 0;
    }
    &__image-wrp {
        width: 80%;
        @media (--viewport-tablet) {
            width: auto;
            margin: 0 -30%;
        }
    }

    &__image {
        display: block;
        width: 100%;
    }
}

.ohlopkov-big-illustration-1 {
    position: relative;
    width: 92%;
    @media (--viewport-laptop-xl) {
        margin-bottom: -1%;
    }
    @media (--viewport-mobile-l) {
        left: -40%;
        width: 160%;
        padding-bottom: 80%;
        margin-bottom: 10%;
    }
    &__division {
        position: absolute;
        top: 23%;
        left: 11.5%;
        width: 105%;
        height: 100%;
        background: url('../../assets/img/articles/ohlopkov/big-illustrations/ohlopkov-big-illustration-1-division.png') 100% 100% / auto 107% no-repeat;
        @media (--viewport-mobile-l) {
            top: 40%;
            left: 0;
        }
    }
}
.ohlopkov-big-illustration-2 {
    display: flex;
    justify-content: center;
    margin-top: 5%;
    @media (--viewport-tablet) {
        margin-top: 0;
    }

    &__image-wrp {
        width: 50%;
        @media (--viewport-tablet) {
            width: 72%;
        }
        @media (--viewport-mobile-l) {
            width: 88%;
        }
    }

    &__image {
        display: block;
        width: 100%;
        margin-bottom: -3%;
        @media (--viewport-tablet) {
            margin-bottom: -6%;
        }
    }
}

.domogakov-big-illustration-1 {
    position: relative;
    width: 90%;
    margin-top: -3%;
    @media (--viewport-tablet) {
        width: 100%;
        margin-left: -4%;
        margin-bottom: -5%;
    }
    @media (--viewport-mobile-l) {
        width: 200%;
        margin-left: -20%;
        margin-top: 74%;
    }
    &::after {
        content: '1943';
        position: absolute;
        z-index: -1;
        top: 6.5%;
        right: 7%;
        font-size: 5.7rem;
        color: rgba(0, 0, 0, 0.3);
        font-weight: bold;
        line-height: 1;
        @media (--viewport-tablet) {
            top: -2%;
            right: 7%;
            font-size: 5.7rem;
        }
        @media (--viewport-mobile-l) {
            font-size: 7rem;
            top: -50%;
            left: 15.5%;
        }
    }

    &__tank {
        position: absolute;
        top: 10%;
        right: -3%;
        width: 35%;
        height: 35%;
        background-image: url('../../assets/img/articles/domogakov/big-illustrations/domogakov-big-illustration-1-tank.png');
        background-size: 100%;
        background-position: 0 0;
        background-repeat: no-repeat;

        transform: scale(calc(1 + var(--transform) * 0.3));

        @media (--viewport-mobile-l) {
            width: 55%;
            height: 55%;
            top: -40%;
            left: 8%;
        }
    }
}
.domogakov-big-illustration-2 {
    position: relative;
    width: 90%;
    margin-top: -24%;
    @media (--viewport-tablet) {
        width: 150%;
        margin-top: -15%;
        margin-bottom: -10%;
        margin-left: 15%;
    }
    @media (--viewport-mobile-l) {
        width: 230%;
        margin-left: -5%;
    }
    &__train {
        position: absolute;
        top: -3%;
        left: 14%;
        width: 38%;
        height: 78%;
        background-image: url('../../assets/img/articles/domogakov/big-illustrations/domogakov-big-illustration-2-train.png');
        background-size: 100%;
        background-position: 0 0;
        background-repeat: no-repeat;

        transform: scale(calc(0.95 + var(--transform) * 0.2)) translateX(calc(var(--transform) * 15%)) translateY(calc(var(--transform) * 10%));
        @media (--viewport-tablet) {
            width: 43%;
            top: -6%;
            left: 13%;
        }
        @media (--viewport-mobile-l) {
            width: 47%;
            height: 80%;
            left: 7%;
            top: -14%;
        }
    }
    &__man {
        position: absolute;
        top: 2%;
        left: -1%;
        width: 30%;
        height: 80%;
        background-image: url('../../assets/img/articles/domogakov/big-illustrations/domogakov-big-illustration-2-man.png');
        background-size: 100%;
        background-position: 0 0;
        background-repeat: no-repeat;
        @media (--viewport-tablet) {
            left: -3%;
        }
        @media (--viewport-mobile-l) {
            left: 0;
            top: 3%;
            background-size: 108%;
        }
        &::before {
            content: '1945';
            position: absolute;
            bottom: 3%;
            left: 24%;
            font-size: 6rem;
            color: rgba(0, 0, 0, 0.3);
            font-weight: bold;
            line-height: 1;
            transform: translateY(calc(var(--transform) * 25%));
            @media (--viewport-tablet) {
                font-size: 7rem;
                left: 10%;
                bottom: 0;
            }
            @media (--viewport-mobile-l) {
                font-size: 6rem;
                bottom: -3%;
                left: 17%;
            }
        }
    }
}
.domogakov-big-illustration-3 {
    position: relative;
    display: flex;
    justify-content: center;
    @media (--viewport-laptop) {
        margin-top: 0%;
    }

    &__binoculars {
        width: 44vw;
        min-width: 350px;
        max-width: 450px;

        @media (--viewport-tablet) {
            margin-bottom: -12%;
        }
    }
    &__binoculars-img {
        display: block;
        width: 100%;
    }
}
</style>
